import React from 'react'
import { Badge, Box, Group, Paper, Text } from '@mantine/core'
import { IconClock, IconFileText, IconLock, IconShieldCheck } from '@tabler/icons-react'
import { ThemeConfig } from '../../utils/themeConfig'

interface SampleReportLinkProps {
  onClick: () => void
  themeConfig: ThemeConfig
}

export default function SampleReportLink({ onClick, themeConfig }: SampleReportLinkProps) {
  return (
    <Paper
      p="lg"
      radius="lg"
      className="cursor-pointer transition-all duration-200 hover:shadow-lg"
      style={{
        border: `1px solid ${themeConfig.surfaceBorderColor}`,
        background: themeConfig.surfaceColor,
      }}
      onClick={onClick}
    >
      <Group gap="md" align="flex-start">
        <Box
          style={{
            padding: '12px',
            borderRadius: '12px',
            backgroundColor: `${themeConfig.primaryColor}20`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconFileText size={24} color={themeConfig.primaryColor} />
        </Box>
        <div className="flex-1">
          <Text size="lg" fw={600} mb="xs">
            查看示例报告
          </Text>
          <Text size="sm" c="dimmed" mb="md">
            了解报告内容和数据详情
          </Text>
          <Group gap="xs">
            <Badge
              size="sm"
              variant="light"
              leftSection={<IconClock size={12} />}
              style={{
                backgroundColor: `${themeConfig.primaryColor}10`,
                color: themeConfig.primaryColor,
              }}
            >
              快速生成
            </Badge>
            <Badge
              size="sm"
              variant="light"
              leftSection={<IconShieldCheck size={12} />}
              style={{
                backgroundColor: `${themeConfig.primaryColor}10`,
                color: themeConfig.primaryColor,
              }}
            >
              权威数据
            </Badge>
            <Badge
              size="sm"
              variant="light"
              leftSection={<IconLock size={12} />}
              style={{
                backgroundColor: `${themeConfig.primaryColor}10`,
                color: themeConfig.primaryColor,
              }}
            >
              安全保密
            </Badge>
          </Group>
        </div>
      </Group>
    </Paper>
  )
}
